export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-pause-57de472a54cda505024f0b2d3b37701e.svg";